import React, { Component } from "react";
import { Translate } from "../services";
import { Link } from "react-router-dom";
import ChangePath from "../services/ServiceApi";
import Cookies from "js-cookie";
class SideNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      active: 0,

      // menu: menus
      menu: [
        { icon: "dashboard", title: "menu_dashboard", link: "/dashboard" },
        { icon: "ma_list", title: "menu_ma_list", link: "/ma_list" },
        { icon: "ma_history", title: "menu_ma_history", link: "/ma_history" },
        {
          icon: "menu_inform",
          title: "menu_inform_problem",
          link: "/inform_problem_list",
        },
        {
          icon: "planning_job",
          title: "menu_planning_job",
          link: "/planning_jobs",
        },
        // {
        //   icon: "team_management",
        //   title: "menu_bus_checking",
        //   link: "/bus_status_checking",
        // },
        {
          icon: "leave_management",
          title: "menu_leave_management",
          link: "/leave_management",
        },
        {
          icon: "select_map",
          title: "Assign Select Map",
          link: "/SelectAssignOperation",
        },
        // {icon: "asset_list", title: "menu_asset_list", link: "/asset_list"},

        //  =============  Comment For Deploy Production =============
        // {
        //   icon: "team_management",
        //   title: "menu_team_management",
        //   link: "/team_management",
        // },
        // {
        //   icon: "team_management",
        //   title: "Bus status checking",
        //   link: "/bus_status_checking"
        // },

        // {
        //   icon: "material_stock",
        //   title: "menu_material_stock",
        //   link: "/materialstock",
        // },
        {
          icon: "photo_report",
          title: "menu_photo_report",
          link: "/photo_report",
        },
        { icon: "report", title: "Report", link: "/report" },
        // {icon: "report.svg", title: "Report", link: "/report"},
        // { icon: "setting", title: "menu_setting", link: "/setting" },
      ],
    };
  }

  componentDidMount() {
    const { menu } = this.state;
    let temp = menu;
    if (Cookies.get("operator_id") === "3") {
      temp.push({
        icon: "team_management",
        title: "menu_bus_checking",
        link: "/bus_status_checking",
      });
      this.setState({
        menu: temp,
      });
    }
    if (Cookies.get("username") === "usr01") {
      temp.push({ icon: "setting", title: "menu_setting", link: "/setting" });
      this.setState({
        menu: temp,
      });
    }
  }
  render() {
    const { menu } = this.state;
    //console.log(menu);
    return (
      <div className="sidenav" id="mySidenav">
        <ul className="nav flex-column">
          {menu.map((item, index) => (
            <li className="nav-item " key={index} style={{ width: "200px" }}>
              {item.title === "menu_photo_report" ? (
                <a
                  className={
                    index === this.props.active
                      ? "nav-link active "
                      : "nav-link "
                  }
                  // to={item.link}
                  // href="process.env.NODE_ENV === "development"? "/MaxiReport/" : "https://planb.maxitask.com/Maxireport"
                  href={
                    window.location.host === "192.168.10.5:3000"
                      ? "http://192.168.10.5:3000/MaxiReport"
                      : "https://planb.maxitask.com/MaxiReport"
                  }
                >
                  <span className="mr-3">
                    <img
                      src={
                        index === this.props.active
                          ? ChangePath.absoluteUrl(
                              "/icon/" + item.icon + "_white.svg"
                            )
                          : ChangePath.absoluteUrl(
                              "/icon/" + item.icon + ".svg"
                            )
                      }
                      width="18"
                      alt="icon"
                    />
                  </span>
                  <span className="font-thai-b" style={{ fontSize: "18px" }}>
                    <Translate text={item.title} />
                  </span>
                </a>
              ) : (
                <Link
                  className={
                    index === this.props.active
                      ? "nav-link active "
                      : "nav-link "
                  }
                  to={item.link}
                >
                  <span className="mr-3">
                    <img
                      src={
                        index === this.props.active
                          ? ChangePath.absoluteUrl(
                              "/icon/" + item.icon + "_white.svg"
                            )
                          : ChangePath.absoluteUrl(
                              "/icon/" + item.icon + ".svg"
                            )
                      }
                      width="18"
                      alt="icon"
                    />
                  </span>
                  <span className="font-thai-b" style={{ fontSize: "18px" }}>
                    <Translate text={item.title} />
                  </span>
                </Link>
              )}
            </li>
          ))}
        </ul>
        <div style={{ textAlign: "center" }}>
          <button
            type="button"
            className="btn  backhome"
            onClick={() =>
              window.location.assign(ChangePath.absoluteUrl("/SelectModules"))
            }
          >
            Home
          </button>
        </div>
      </div>
    );
  }
}
export default SideNav;
